export default "__VITE_ASSET__DDEsRwBU__"